module.exports = __webpack_public_path__ + "static/img/jianshiSkill.2619985.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/jianshiSkill.png
// module id = R5Do
// module chunks = 0